"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ENDPOINTS = void 0;
var endpoints_1 = require("./endpoints");
Object.defineProperty(exports, "API_ENDPOINTS", { enumerable: true, get: function () { return endpoints_1.API_ENDPOINTS; } });
//# sourceMappingURL=index.js.map